import { render, staticRenderFns } from "./paymentActivity.vue?vue&type=template&id=8b21bfc4&"
import script from "./paymentActivity.vue?vue&type=script&lang=js&"
export * from "./paymentActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports